module.exports = __webpack_public_path__ + "static/media/07.6f3e97e0.png";